import React from 'react';
import styled, { StyledComponentClass } from 'styled-components';
import { Group } from '@vx/group';

import { ScaledArc } from './';
import { colors } from '../../styles';

export interface CircleProps {
  className?: string;
  children?: any;
  color?: string;
  score: number;
  radius?: number;
  innerRadius?: number;
  outerRadius?: number;
  startAngle?: number;
  endAngle?: number;
  strokeWidth?: number;
}

class Circle extends React.Component<CircleProps, any> {
  static defaultProps = {
    color: colors.success,
    endAngle: 360,
    strokeWidth: 4,
    radius: 50,
    startAngle: 0,
  };

  public render() {
    const {
      className,
      children,
      color,
      innerRadius,
      outerRadius,
      score,
      radius,
      startAngle,
      endAngle,
      strokeWidth,
    } = this.props;
    const size = outerRadius || radius;
    const diameter = size * 2;

    const arcProps = {
      fill: color,
      innerRadius: innerRadius || radius * 0.84,
      outerRadius: outerRadius || radius,
      startAngle,
      endAngle,
    };

    return (
      <svg className={`${className}`} width={diameter} height={diameter}>
        <g>
          <ScaledArc {...arcProps} className="background" score={100} />
          {strokeWidth > 0 && (
            <ScaledArc
              {...arcProps}
              className="pathStroke"
              score={score}
              fill="transparent"
              stroke="white"
              strokeWidth={strokeWidth}
            />
          )}
          <ScaledArc {...arcProps} className="fill" score={score} />
        </g>

        {children && (
          <Group top={size} left={size}>
            {React.Children.map(children, child =>
              React.cloneElement(child as any, { size }),
            )}
          </Group>
        )}
      </svg>
    );
  }
}

const StyledCircle = styled(Circle)`
  .background {
    opacity: 0.2;
  }
`;

export default StyledCircle;
